export const MAX_TAG_SHOWN = 2;
